import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function onClassMaterialResponse(response) {
  return {
    type: types.CLASS_MATERIAL_RESPONSE,
    response
  };
}

export function fetchMaterialData(response) {
  return {
    type: types.CLASS_MATERIAL_DOWNLOADS,
    response
  };
}

export const listClassMaterial = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/dc/student/material';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error || !Object.keys(data).includes('data')) {
        dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
        return 'Error';
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        dispatch(logOut());
        return 'Logged Out';
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(onClassMaterialResponse(data));
      return onClassMaterialResponse(data);
    })
    .catch(() => {
      return 'Error';
    });
};

export const listClassMaterialDetails = async (
  uniqueCode,
  params,
  dispatch
) => {
  const jwtToken = params;
  const body = {
    UniqueCode: uniqueCode
  };
  const url = 'api/dc/student/material';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error || !Object.keys(data).includes('data')) {
        dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
        return 'Error';
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        dispatch(logOut());
        return 'Logged Out';
      }
      dispatch(fetchMaterialData(data));
      return fetchMaterialData(data);
    })
    .catch(() => {
      return 'Error';
    });
};
